// Global UI
export const SHOW_NOTIFICATION   = "global/SHOW_NOTIFICATION"
export const MAIN_MENU_SHOWN     = "global/MAIN_MENU_SHOWN"
export const CURRENT_BREADCRUMBS = "global/CURRENT_BREADCRUMBS"
export const HIDE_BREADCRUMBS    = "global/HIDE_BREADCRUMBS"
export const FS_LOADING          = "global/FS_LOADING"
export const TOPBAR_DENSE        = "global/TOPBAR_DENSE"
export const GLOBAL_SEARCH_TERM  = "global/GLOBAL_SEARCH_TERM"
export const BACKGROUND_ICON     = "global/BACKGROUND_ICON"
export const DASHBOARD_STATS     = "global/DASHBOARD_STATS"

export const GLOBAL_NOTIFICATIONS        = "global/GLOBAL_NOTIFICATIONS" 
export const ADD_GLOBAL_NOTIFICATIONS    = "global/ADD_GLOBAL_NOTIFICATIONS" 
export const REMOVE_GLOBAL_NOTIFICATIONS = "global/REMOVE_GLOBAL_NOTIFICATIONS" 
export const CLEAR_GLOBAL_NOTIFICATIONS  = "global/CLEAR_GLOBAL_NOTIFICATIONS"
export const NOTIFICATION_SEEN           = "global/NOTIFICATION_SEEN"
export const SYSTEM_MESSAGES             = "global/SYSTME_MESSAGES"
export const SYSTEM_MESSAGES_META        = "global/SYSTEM_MESSAGES_META"
export const USER_MESSAGES_META          = "global/USER_MESSAGES_META"
export const USER_MESSAGES               = "global/USER_MESSAGES"
export const OVERAL_SYSTEM_MESSAGES_META = "global/OVERALL_SYSTEM_MESSAGES_META"
export const APPLICATION_SYSTEM_MESSAGES = "global/APPLICATION_SYSTEM_MESSAGES"
export const SEND_USER_MESSAGE           = "global/SEND_USER_MESSAGE"
export const ADD_USER_MESSAGE           = "global/ADD_USER_MESSAGE"

// Authentication
export const USER_LOGIN         = "user/USER_LOGIN"

export const USER_REQUEST_RESET_PASSWORD = "user/USER_REQUEST_RESET_PASSWORD"
export const USER_RESET_PASSWORD         = "user/USER_RESET_PASSWORD"
export const USER_RESET_PASSWORD_TOKEN   = "user/USER_RESET_PASSWORD_TOKEN"

export const USER_SWITCH_TENANT = "user/USER_SWITCH_TENANT"
export const LOGIN_SUCCESS      = "user/LOGIN_SUCCESS"
export const LOGOUT             = "user/LOGOUT"
export const IS_AUTHENTICATED   = "user/IS_AUTHENTICATED"
export const USER_ACCESS_TOKEN  = "user/USER_ACCESS_TOKEN"
export const USERS_ONLINE       = "user/USERS_ONLINE"

// Hard data
export const HD_AGGREGATE_MODES    = "hardData/AGGREGATE_MODES"
export const HD_MEASUREMENT_UNITS  = "hardData/MEASUREMENT_UNITS"
export const HD_CALCULATION_UNITS  = "hardData/HD_CALCULATION_UNITS"
export const HD_CUSTOM_FIELD_TYPES = "hardData/HD_CUSTOM_FIELD_TYPES"
export const HD_OPERATORS          = "hardData/HD_OPERATORS"
export const HD_MARKER_SHAPES      = "hardData/HD_MARKER_SHAPES"

// HARDWARE
export const HARDWARE_PRESETS = "global/HARDWARE_PRESETS"

// TIMETABLES
export const TIME_TABLES       = "global/TIME_TABLES"
export const SAVE_TIME_TABLE   = "global/SAVE_TIME_TABLE"
export const DELETE_TIME_TABLE = "global/DELETE_TIME_TABLE"

// USER
export const CURRENT_USER = "user/CURRENT_USER"
export const LOAD_CURRENT_USER = "user/LOAD_CURRENT_USER"
export const USER = "user/USER"
export const USERS = "user/USERS"
export const USERS_META = "user/USERS_META"
export const USERS_PAGINATION = "user/USERS_PAGINATION"
export const USERS_SEARCH = "user/USERS_SEARCH"
export const SAVE_USER = "user/SAVE_USER"


export const SAVE_USER_ROLE = "user/SAVE_USER_ROLE"
export const USER_ROLES    = "user/USER_ROLES"
export const SYNC_USER_ROLES = "user/SYNC_USER_ROLES"

export const USER_ROLE_PERMISSIONS            = "user/USER_PERMISSIONS"
export const USER_ROLE_PERMISSIONS_PAGINATION = "user/USER_PERMISSIONS_PAGINATION"
export const SYNC_USER_ROLE_PERMISSIONS       = "user/SYNC_USER_PERMISSIONS"
export const USER_ROLE_PERMISSIONS_SEARCH     = "user/USER_PERMISSIONS_SEARCH"
export const USER_FAVORITE_ASSETS             = "user/USER_FAVORITE_ASSETS"
export const USER_FAVORITE_ASSETS_META        = "user/USER_FAVORITE_ASSETS_META"

export const USER_FAVORITE_ASSET_GROUPS       = "user/USER_FAVORITE_ASSET_GROUPS"
export const USER_FAVORITE_ASSET_GROUPS_META  = "user/USER_FAVORITE_ASSET_GROUPS_META"

export const SAVE_ASSET_GROUPS_ON_ROLE = "user/SAVE_ASSET_GROUPS_ON_ROLE"

export const SAVE_USER_FAVORITE_ASSET         = "user/SAVE_USER_FAVORITE_ASSET"
export const SAVE_USER_FAVORITE_ASSET_GROUP   = "user/SAVE_USER_FAVORITE_ASSET_GROUP"

// ASSETS
export const ASSET                    = "asset/ASSET"
export const ASSET_DOSSIER_ITEMS      = "asset/ASSET_DOSSIER_ITEMS"
export const ASSET_DOSSIER_ITEMS_META = "asset/ASSET_DOSSIER_ITEMS_META"

export const ASSET_LAST_UPDATE       = "asset/ASSET_LAST_UPDATE"
export const ASSET_UNIT              = "asset/ASSET_UNIT"
export const ASSETS                  = "asset/ASSETS"
export const MAP_ASSETS              = "asset/MAP_ASSETS"
export const MAP_ASSET_GROUPS_HIDDEN = "asset/MAP_ASSET_GROUPS_HIDDEN"
export const MAP_ASSET_HIDE_GROUP    = "asset/MAP_ASSET_HIDE_GROUP"
export const ASSET_MAP_UPDATER_STOP  = "asset/ASSET_MAP_UPDATER_STOP"

export const ASSET_GROUP         = "asset/ASSET_GROUP"
export const ASSET_GROUPS        = "asset/ASSET_GROUPS"
export const ASSET_GROUP_SEARCH  = "asset/ASSET_GROUP_SEARCH"
export const ASSET_GROUPS_META   = "asset/ASSET_GROUPS_META"

export const SAVE_ASSET_GROUP   = "asset/SAVE_ASSET_GROUP"
export const DELETE_ASSET_GROUP = "asset/DELETE_ASSET_GROUP"

export const ASSET_TYPES        = "asset/ASSET_TYPES"
export const SAVE_ASSET_TYPE    = "asset/SAVE_ASSET_TYPE"
export const DELETE_ASSET_TYPE  = "asset/DELETE_ASSET_TYPE"
export const ASSETS_SEARCH      = "asset/ASSETS_SEARCH"
export const ASSETS_SEARCH_META = "asset/ASSETS_SEARCH_META"

export const UNIT_TYPES                        = "asset/UNIT_TYPES"
export const DATA_FIELD_TYPES                  = "asset/DATA_FIELD_TYPES"

export const SAVE_DATA_FIELD                   = "asset/SAVE_DATA_FIELD"
export const SAVE_DATA_FIELD_STATUS            = "asset/SAVE_DATA_FIELD_STATUS"
export const UNIT_TYPE_DATA_FIELDS             = "event/UNIT_TYPE_DATA_FIELDS"
export const UNIT_TYPE_STATUSES_BY_DATA_FIELDS = "event/UNIT_TYPE_STATUSES_BY_DATA_FIELDS"

export const SAVE_UNIT_TYPE_TIMESERIE     = "asset/SAVE_UNIT_TYPE_TIMESERIE"
export const ASSET_TIME_SERIE             = "asset/ASSET_TIME_SERIE"
export const ASSET_PROCESSED_ACTIONS      = "asset/ASSET_PROCESSED_ACTIONS"
export const ASSET_PROCESSED_ACTIONS_META = "asset/ASSET_PROCESSED_ACTIONS_META"
export const ASSET_PROCESSED_EVENTS       = "asset/ASSET_PROCESSED_EVENTS"
export const ASSET_PROCESSED_EVENTS_META  = "asset/ASSET_PROCESSED_EVENTS_META"
export const ASSET_MAP_UPDATER_START      = "asset/ASSET_MAP_UPDATER_START"
export const ASSET_MAP_UPDATER            = "asset/ASSET_MAP_UPDATER"
export const ASSET_SELECTION_FILTER       = "asset/ASSET_SELECTION_FILTER"
export const ASSET_GROUP_CUSTOM_FIELDS    = "asset/ASSET_GROUP_CUSTOM_FIELDS"
export const ASSET_ROUTES                 = "asset/ROUTES"
export const ASSET_DELETE_IMAGE           = "asset/ASSET_DELETE_IMAGE"
export const SAVE_ASSET                   = "asset/SAVE_ASSET"
export const SAVE_ASSET_CUSTOM_FIELDS     = "asset/SAVE_ASSET_CUSTOM_FIELDS"
export const ASSET_LOCATIONS              = "asset/ASSET_LOCATIONS"
export const ASSET_LOCATIONS_META         = "asset/ASSET_LOCATIONS_META"

// ASSET UNIT EVENTS
export const PREDEFINED_EVENTS = "event/PREDEFINED_EVENTS"

export const EVENT_TYPES = "event/EVENT_TYPES"
export const EVENT_SEVERITIES = "event/EVENT_SEVERITIES"
export const SAVE_UNIT_TYPE_EVENT = "event/SAVE_UNIT_TYPE_EVENT"
export const SAVE_UNIT_TYPE_EVENT_ACTION = "event/SAVE_UNIT_TYPE_EVENT_ACTION"

export const SAVE_UNIT_TYPE_ACTION_DONE_EVENT = "event/SAVE_UNIT_TYPE_ACTION_DONE_EVENT"
export const SAVE_UNIT_TYPE_ACTION_CANCEL_EVENT = "event/SAVE_UNIT_TYPE_ACTION_CANCEL_EVENT"

export const EVENT_ACTIONS         = "event/EVENT_ACTIONS"
export const UNIT_TYPE_EVENT       = "event/UNIT_TYPE_EVENT"
export const UNIT_TYPE_EVENTS      = "event/UNIT_TYPE_EVENTS"

export const SAVE_ASSET_USER_EVENT = "event/SAVE_ASSET_USER_EVENT"        

export const EVENTS_HISTORIC       =  "events/EVENTS_HISTORIC"
export const ACTIONS_HISTORIC      =  "events/ACTIONS_HISTORIC"

// export const EVENT_WORKFLOW         = "event/EVENT_WORKFLOW"
export const ASSET_EXECUTE_ACTION = "asset/ASSET_EXECUTE_ACTION"
export const ASSET_CANCEL_ACTION = "asset/ASSET_CANCEL_ACTION"
export const DISCARD_PROCESSED_EVENT = "asset/DISCARD_PROCESSED_EVENT"

export const SAVE_ASSET_GEO_ZONE_EVENT = "asset/SAVE_ASSET_GEO_ZONE_EVENT"
export const DELETE_ASSET_GEO_ZONE_EVENT = "asset/DELETE_ASSET_GEO_ZONE_EVENT"

export const SAVE_ASSET_GROUP_GEO_ZONE_EVENT = "asset/SAVE_ASSET_GROUP_GEO_ZONE_EVENT"
export const DELETE_ASSET_GROUP_GEO_ZONE_EVENT = "asset/DELETE_ASSET_GROUP_GEO_ZONE_EVENT"

/*
export const ADD_GEO_ZONE_EVENT_ON_ASSET = "geo/ADD_GEO_ZONE_EVENT_ON_ASSET"
export const DELETE_GEO_ZONE_EVENT_ON_ASSET = "geo/DELETE_GEO_ZONE_EVENT_ON_ASSET"
*/

export const ASSET_GEO_ZONE_EVENTS = "asset/ASSET_GEO_ZONE_EVENTS"
export const ASSET_GEO_ZONE_EVENTS_SEARCH = "asset/ASSET_GEO_ZONE_EVENTS_SEARCH"
export const ASSET_GEO_ZONE_EVENTS_PAGINATION = "asset/ASSET_GEO_ZONE_EVENTS_PAGINATION"

export const ASSET_GROUP_GEO_ZONE_EVENTS = "asset/ASSET_GROUP_GEO_ZONE_EVENTS"
export const ASSET_GROUP_GEO_ZONE_EVENTS_SEARCH = "asset/ASSET_GROUP_GEO_ZONE_EVENTS_SEARCH"
export const ASSET_GROUP_GEO_ZONE_EVENTS_META = "asset/ASSET_GROUP_GEO_ZONE_EVENTS_PAGINATION"

export const ASSET_GROUP_UNIT_TYPE_GEO_ZONE_EVENTS = "asset/ASSET_GROUP_UNIT_TYPE_GEO_ZONE_EVENTS"
export const ASSET_GROUP_UNIT_TYPE_GEO_ZONE_EVENTS_META = "asset/ASSET_GROUP_UNIT_TYPE_GEO_ZONE_EVENTS_META"


export const UNIT_TYPE_GEO_ZONE_EVENTS = "geo/UNIT_TYPE_GEO_ZONE_EVENTS"
export const UNIT_TYPE_GEO_ZONE_EVENTS_SEARCH = "geo/UNIT_TYPE_GEO_ZONE_EVENTS_SEARCH"
export const UNIT_TYPE_GEO_ZONE_EVENTS_PAGINATION = "geo/UNIT_TYPE_GEO_ZONE_EVENTS_PAGINATION"

export const GEO_CODE_ADDRESS       = "geo/GEO_CODE_ADDRESS"
export const GEO_ZONE               = "geo/GEO_ZONE"
export const SAVE_GEO_ZONE          = "geo/SAVE_GEO_ZONE"
export const CLEAR_GEO_ZONES        = "geo/CLEAR_GEO_ZONES"
export const SAVE_GEO_ZONE_EVENT    = "geo/SAVE_GEO_ZONE_EVENT"
export const SAVE_GEO_ZONE_TYPE     = "geo/SAVE_GEO_ZONE_TYPE"
export const GEO_ZONES              = "geo/GEO_ZONES" 
export const GEO_ZONES_META         = "geo/GEO_ZONES_META"
export const SEARCH_GEO_ZONES       = "geo/SEARCH_GEO_ZONES"
export const GEO_ZONE_TYPES         = "geo/GEO_ZONE_TYPES"
export const GEO_ZONE_CUSTOM_FIELDS = "geo/GEO_ZONE_CUSTOM_FIELDS"
export const SAVE_CUSTOM_FIELDS_ON_GEO_ZONE    = "geo/SAVE_CUSTOM_FIELDS_ON_GEO_ZONE"
export const SAVE_GEO_ZONE_CUSTOM_FIELD_VALUES = "geo/SAVE_GEO_ZONE_CUSTOM_FIELD_VALUES"
export const ASSETS_IN_GEO_ZONE_SINCE          = "geo/ASSETS_IN_GEO_ZONE_SINCE"

export const ASSETS_WITHIN_GEO_ZONE    = "geo/ASSETS_WITHIN_GEO_ZONE"
export const EVENTS_WITHIN_GEO_ZONE    = "geo/EVENTS_WITHIN_GEO_ZONE"
export const GEO_ZONE_PROCESSED_EVENTS = "geo/GEO_ZONE_PROCESSED_EVENTS"

export const GEO_ZONE_EVENTS_ON_UNIT_TYPE_AND_GEO_ZONE = "geo/GEO_ZONE_EVENTS_ON_UNIT_TYPE_AND_GEO_ZONE"
export const DELETE_GEO_ZONE     = "geo/DELETE_GEO_ZONE"

export const ASSET_GROUP_GEO_ZONE_EVENTS_ON_GEO_ZONE      = "geo/ASSET_GROUPS_EVENTS_ON_GEO_ZONE"
export const ASSET_GROUP_GEO_ZONE_EVENTS_ON_GEO_ZONE_META = "geo/ASSET_GROUPS_EVENTS_ON_GEO_ZONE_META"

// CUSTOM FIELDS
export const CUSTOM_FIELD_SEARCH               = "customFields/CUSTOM_FIELD_SEARCH"
export const CUSTOM_FIELDS                     = "customFields/CUSTOM_FIELDS"
export const PROTECTED_CUSTOM_FIELDS           = "customFields/PROTECTED_CUSTOM_FIELDS"
export const CUSTOM_FIELDS_PAGINATION          = "customFields/CUSTOM_FIELDS_PAGINATION"
export const SAVE_CUSTOM_FIELD                 = "customFields/SAVE_CUSTOM_FIELD"
export const CUSTOM_FIELD_TYPES                = "customFields/CUSTOM_FIELD_TYPES"
export const SAVE_CUSTOM_FIELD_ALLOWED_VALUE   = "customFields/SAVE_CUSTOM_FIELD_ALLOWED_VALUE"
export const DELETE_CUSTOM_FIELD_ALLOWED_VALUE = "customFields/DELETE_CUSTOM_FIELD_ALLOWED_VALUE"
export const SAVE_CUSTOM_FIELDS_ON_ASSET_GROUP = "customFields/SAVE_CUSTOM_FIELDS_ON_ASSET_GROUP"

export const CURRENT_TRAFFIC_DATA              = "traffic/CURRENT_TRAFFIC_DATA"
